// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1dVZm","sendOtp":"AuthorizeToLogin_sendOtp__2ef2N"};